import React, { useEffect, useState } from 'react';
import { Button, Input, message, Modal } from 'antd';
import { useFormik } from 'formik';
import axios from '../../util/Api';


const AdminWhatsapp = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});

  useEffect(() => {
    if (open) {
      setLoading(true);
      const url = `/faq/contact`;
      axios.get(url).then(resp => {
        setContact(resp.data);
        setLoading(false);
      }).catch(err => {
        message.error("Gagal memuat data contact");
      });
    }
  }, [open]);

  const formik = useFormik({
    initialValues: {
      number: contact.number,
      name: contact.name
    },
    onSubmit: (values, actions) => {
      const url = `/faq/contact-update`;
      const data = {
        number: values.number ? values.number : contact.number,
        name: values.name ? values.name : contact.name,
      };
      axios.post(url, data).then(resp => {
        message.success(`Kontak Admin telah berhasil disimpan`);
        setOpen(false);
        actions.setSubmitting(false);
      }).catch(err => {
        message.error("Gagal menyimpan Kontak Admin");
      });
    }
  });

  const handleOk = () => {
    formik.submitForm();
  }

  const handleCancel = () => {
    setOpen(false);
  }

  return (
    <>
      <Button type="primary" ghost onClick={() => setOpen(true)}>Ganti Whatsapp Admin</Button>
      <Modal title="Ganti Nomor Whatsapp Admin" visible={open} onOk={handleOk} onCancel={handleCancel} okButtonProps={{loading : formik.isSubmitting}} okText="Simpan Perubahan" cancelText="Batal">
        {loading ? "Sedang memuat..." : (
          <form onSubmit={formik.handleSubmit}>
            <div className="gx-mb-2">
              <label htmlFor="number" className="gx-mb-1">Nomor Whatsapp</label>
              <Input name="number" onChange={formik.handleChange} value={formik.values.number} defaultValue={contact.number} />
            </div>

            <div className="gx-mb-2">
              <label htmlFor="name" className="gx-mb-1">Nama Admin</label>
              <Input name="name" onChange={formik.handleChange} value={formik.values.name} defaultValue={contact.name} />
            </div>

          </form>
        )}
      </Modal>
    </>
  );
}

export default AdminWhatsapp;